import ParenthesisClass from '../parenthesisClass';

const openParenthesis = new ParenthesisClass('(', 'open');

export default openParenthesis;
